export const DEFAULT_COUNTRY_NAME = 'Magyarország';